<template>
  <b-list-group flush class="mb-4">
    <b-list-group-item
      action
      v-for="(request, index) in requests"
      :key="'member-' + index"
      class="cursor-pointer py-3 px-4"
    >
      <JoinRequest :request="request" />
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import JoinRequest from "./JoinRequest";
import { mapState } from "vuex";

export default {
  components: {
    JoinRequest,
  },
  computed: {
    ...mapState("channel", {
      requests: "selectedChannelJoinRequest",
    }),
  },
};
</script>
